import React from "react";

function InviteIcon() {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.52304 3.5874V8.50192L11.7513 10.7358"
        stroke="#F44336"
        strokeWidth="1.21969"
        strokeLinecap="round"
      />
      <path
        d="M4.35766 13.4165C5.69432 14.7109 7.51399 15.5072 9.51919 15.5072C13.6227 15.5072 16.9493 12.1723 16.9493 8.05855C16.9493 3.94475 13.6227 0.609863 9.51919 0.609863C6.19322 0.609863 3.37766 2.80069 2.43008 5.82137"
        stroke="#F44336"
        strokeWidth="1.21969"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.50233 5.13111L2.21399 6.65952L0.609894 4.48096"
        stroke="#F44336"
        strokeWidth="1.21969"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default InviteIcon;
